import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";
import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { SWAL_SETTINGS, showFilterlist } from "../../../../utils/Constants";
import { TrimText, capitalizeFirstLetter, formateDateWithMonth, handleServerValidations } from "../../../../utils/commonfunction";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import * as inquiryServices from "../../services/inquiry.services";
import { useTranslation } from "react-i18next";
import CustomRangepicker from "../../common/rangepicker";
import { Tooltip, Whisper } from "rsuite";

const InquiryTable = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: t("Inquires"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        inquiryServices
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch]);

  const viewfunction = (row) => {
    navigate(`/admin/inquiry/view/${row._id}`);
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  const Deletefunction = (data) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#403fad",
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        console.log(data);
        formdata.append("o_id", data);
        inquiryServices
          .Delete(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  };

  const editInquiry = (data) => {
    console.log("hit");
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("You are about to edit this inquiry"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        formdata.append("o_id", data.id);
        formdata.append("status", data.status);
        inquiryServices
          .Edit(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  const badgeClassName = (status) => (status === "New" ? "badge badge-pill badge-danger-light" : status === "Responded" ? "badge badge-pill badge-info-light" : status === "In Progress" ? "badge badge-pill badge-primary-light" : "badge badge-pill badge-success-light");

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Inquires")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("Search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    className="cp"
                    data={[
                      { name: "Status", status__id: "" },
                      { name: "New", status__id: "New" },
                      { name: "In Progress", status__id: "In Progress" },
                      { name: "Responded", status__id: "Responded" },
                      { name: "Closed", status__id: "Closed" },
                    ]}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                  {t("Reset filter")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table id="example-input" className="table table-bordered card-table border-top text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="sr_head">{t("admin.faq.list_heading_sno")}</th>
                    {/* <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_name")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="name"
                        />
                      </div>
                    </th> */}
                    <th>
                      <div className="sorting_column">
                        <span>{t("Name")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Email")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Created By</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="role" />
                      </div>
                    </th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("Created Date")}</span>
                        <Sorting sort={sorting} defaultSorting={defaultSorting} handleSort={handleSort} column="createdAt" />
                      </div>
                    </th>
                    <th className="action_head">{t("Status")}</th>
                    <th className="action_head">{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={13}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td className="text-capitalize">{row?.role==='business'?
                              row?.createdBy?.business_name ? capitalizeFirstLetter(TrimText(row.createdBy.business_name, 40)) : row?.createdBy?.fullName ? capitalizeFirstLetter(TrimText(row.createdBy.fullName, 40)) : "N/A": 
                              capitalizeFirstLetter(TrimText(row.name, 40)) 
                              
                              }</td>
                              <td>{row?.email ? row.email : "N/A"}</td>
                              <td>{row?.role ? capitalizeFirstLetter(TrimText(row.role, 40)) : "N/A"}</td>
                              <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                              <td>
                                <div className="btn-group mlAction">
                                  <span className="dropdown-toggle no-after" data-bs-toggle="dropdown" aria-expanded="false" aria-describedby="control-id-hover">
                                    <i
                                      className="ri-settings-5-fill me-1"
                                      style={{
                                        color: "rgb(0, 0, 0)",
                                        fontSize: 18,
                                        cursor: "pointer",
                                        marginLeft: 6,
                                      }}
                                    />
                                  </span>
                                  <ul className="dropdown-menu" style={{}}>
                                    <li>
                                      <button className="dropdown-item" onClick={() => editInquiry({ id: row._id, status: "New" })}>
                                        New
                                      </button>
                                    </li>
                                    <li>
                                      <button className="dropdown-item" onClick={() => editInquiry({ id: row._id, status: "In Progress" })}>
                                        In Progress
                                      </button>
                                    </li>
                                    <li>
                                      <button className="dropdown-item" onClick={() => editInquiry({ id: row._id, status: "Responded" })}>
                                        Responded
                                      </button>
                                    </li>
                                    <li>
                                      <button className="dropdown-item" onClick={() => editInquiry({ id: row._id, status: "Closed" })}>
                                        Closed
                                      </button>
                                    </li>
                                  </ul>
                                </div>

                                <span className={badgeClassName(row.status)}>{row.status}</span>
                              </td>

                              <td>
                                <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                  <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn view"
                                        onClick={() => {
                                          viewfunction(row);
                                        }}>
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Delete</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn delete"
                                        onClick={() => {
                                          Deletefunction(row?._id);
                                        }}>
                                        <i className="ri-delete-bin-6-fill"></i>
                                      </button>
                                    </Whisper>
                                  </div>
                                </div>
                              </td>
                              {/* <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn "
                                    onClick={() => {
                                      viewfunction(row);
                                    }}>
                                    {t("btn_view")}
                                  </button>
                                </div>
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={13} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? <CustomPagination datalength={datalength} itemperpage={itemperpage} setPage={setPage} currentPage={page} pageRoute={[{ name: "PageTable", path: "/admin/inquiry/list" }]} /> : ""}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default InquiryTable;

function StatusFilter(props) {
  const { t } = useTranslation();
  const showFilterlistNew = props.data && props.data.length > 0 ? props.data : [];

  const handleChange = (e) => {
    if (e.target.value) {
      props.prepareSearch("status", e.target.value);
    } else {
      props.prepareSearch("status", "");
    }
  };

  return (
    <div className="form-group mb-0 filter_icon_container filter_design">
      <i className="fa fa-filter mr-2 filter_icon"></i>
      <div className="select-down-arrow">
        <select className="form-control cp" onChange={handleChange} id="defaultstatus">
          {showFilterlistNew &&
            showFilterlistNew.length > 0 &&
            showFilterlistNew.map((option, i) => {
              return (
                <option key={i} value={option.status__id}>
                  {t(option.name)}
                </option>
              );
            })}
        </select>
      </div>
    </div>
  );
}
